module.exports = __webpack_public_path__ + "static/media/customize_add_blocks_2.07956b33.png";